import { useMediaQuery } from "@mui/material";

const useResponsive = () => {
  const isBelowMediumScreen = useMediaQuery("(max-width: 900px)");
  const isAboveMediumScreen = useMediaQuery("(max-width: 1200px)");
  const isAboveLargeScreen = useMediaQuery("(min-width: 1450px)");
  const isBelowLargeScreen = useMediaQuery("(max-width: 1500px)");
  const isDesktopScreen = useMediaQuery("(min-width: 900px)");
  const isMobileScreen = useMediaQuery("(max-width: 480px)");
  const isTabletScreen = useMediaQuery("(max-width: 900px)");

  const isSmartMobileScreen = useMediaQuery("(max-width: 640px)");

  return {
    isBelowMediumScreen,
    isAboveMediumScreen,
    isBelowLargeScreen,
    isDesktopScreen,
    isMobileScreen,
    isTabletScreen,
    isAboveLargeScreen,
    isSmartMobileScreen
  };
};

export default useResponsive;